$('#appointment-form').submit(function (e) {
    e.preventDefault();

    var phone = $('#appointment-form').find('[name="phone"]');

    var data = {
        phone: phone.val(),
        name: 'appointment',
        email: 'appointment',
        comment: 'appointment',
    };

    $.ajax({
        type: $('#appointment-form').attr('method'),
        url: $('#appointment-form').attr('action'),
        data: data,
        success: function (response) {
            if (response.result === 'success') {
                phone.val('');
                $('#appointmentModal').modal('hide');
                $('#appointmentSuccessMessage').fadeIn();
                setTimeout(function() {
                    $('#appointmentSuccessMessage').fadeOut();
                }, 3000);
            } else {
                $('#appointmentErrorMessage').fadeIn();

                setTimeout(function() {
                    $('#appointmentErrorMessage').fadeOut();
                }, 3000);
            }
        },
        error: function (response) {
            $('#appointmentErrorMessage').fadeIn();

            setTimeout(function() {
                $('#appointmentErrorMessage').fadeOut();
            }, 3000);
        }
    });
});
